import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

export const SURQUAL_LOS_PAGE: ConfigurationPageTable = {
  description: "CONF_DESC_SELFMAPPING_LOS",
  type: ConfigurationPageType.TABLE,
  label: "LOS",
  menuLabel: "LOS",
  pageLabel: "LOS_TITLE_SURQUAL",
  path: "los",
  model: {
    entityName: "short_name",
    label: "LOS",
    path: "/api/los",
    name: "LOS",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 2,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 3,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 4,
        label: "LONG_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "min_stay",
        order: 5,
        label: "MIN_STAY",
        visible: true,
      },
      {
        align: "right",
        key: "max_stay",
        order: 6,
        label: "MAX_STAY",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/los/export" },
    import: { path: "/api/los/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "min_stay",
        label: "MIN_STAY",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "max_stay",
        label: "MAX_STAY",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "min_stay",
        flex: "50%",
        required: true,
      },
      {
        key: "max_stay",
        flex: "50%",
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "min_stay",
        flex: "50%",
        required: true,
      },
      {
        key: "max_stay",
        flex: "50%",
      },
    ],
    deletable: true,
  },
};
